import {
	Button,
	Dialog,
	DialogContent,
	IconButton,
	Paper,
	Slide,
	TextField,
	Toolbar,
	Typography,
	createTheme,
	useMediaQuery,
} from "@mui/material"
import { forwardRef, useContext, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import { adminAnswerQuestionV2 } from "../util/firebase"
import { AdminContext } from "../views/Admin"

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

const AnswerQuestionDialog = ({ answerDialogOpen, setAnswerDialogOpen, question, setQuestions }) => {
	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))
	const adminContext = useContext(AdminContext)
	const handleOpenSnackbar = adminContext.handleOpenSnackbar

	const [answer, setAnswer] = useState("")

	const handleClose = async () => {
		try {
			const response = await adminAnswerQuestionV2({ questionId: question.id, postId: question.postId, answer: answer })
			if (response.data.status === 0) {
				handleOpenSnackbar("שאלה נענתה בהצלחה!", "success")
				setQuestions((prevState) => [...prevState].filter((q) => q.id !== question.id))
				setAnswerDialogOpen(false)
			} else {
				handleOpenSnackbar("תקלה במענה לשאלה", "error")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה במענה לשאלה", "error")
		}
	}

	return (
		<Dialog
			fullScreen={!matches}
			open={answerDialogOpen}
			onClose={() => setAnswerDialogOpen(false)}
			TransitionComponent={Transition}
			PaperProps={{
				style: {
					backgroundColor: "white",
					maxHeight: "715px",
				},
			}}
			maxWidth={"md"}
			/* scroll="body" */
			/* sx={{ maxHeight: "715px"}} */
		>
			<Toolbar>
				<IconButton edge="start" color="inherit" onClick={() => setAnswerDialogOpen(false)} aria-label="close">
					<CloseIcon />
				</IconButton>
				<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
					מענה לשאלה
				</Typography>
			</Toolbar>
			<DialogContent dividers>
				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
						justifyContent: "flex-start",
						flexWrap: "wrap",
					}}
				>
					<Typography variant="h6">שאלה: {question?.question}</Typography>
					<TextField
						fullWidth={false}
						label="תשובה"
						multiline
						rows={5}
						sx={{ m: 2 /* , height: "100%" */ }}
						value={answer}
						onChange={(e) => setAnswer(e.target.value)}
					/>
				</Paper>
				<Button
					sx={{ backgroundColor: mdTheme.palette.primary.main, width: matches ? "120px" : "auto", mt: 2, mb: 2 }}
					onClick={() => handleClose()}
					variant="contained"
				>
					שמירה
				</Button>
			</DialogContent>
		</Dialog>
	)
}

export default AnswerQuestionDialog
